export default __webpack_public_path__ + "static/media/Skirt of the Ghost of the Veldt.39328bb5.jpg";